<template>
    <form method="POST" action="https://tracker.aopa.ru/api/lk/entryBlank" ref="getEntryBlankForm" target="_blank">
        <input type="hidden" name="lastname" v-model="lastname" />
        <input type="hidden" name="firstname" v-model="firstname" />
        <input type="hidden" name="middlename" v-model="middlename" />
        <input type="hidden" name="nameForCard" v-model="nameForCard" />
        <input type="hidden" name="address" v-model="addressString" />
        <input type="hidden" name="birthdate" v-model="birthdate" />
        <input type="hidden" name="email" v-model="emailsString" />
        <input type="hidden" name="phone" v-model="phonesString" />
        <input type="hidden" name="photo" v-model="photo" />
        <button type="submit" class="btn btn-outline-warning btn-sm">Распечатать заявление</button>
    </form>
</template>
<script>
import { convertYMDtoDMY } from '@/utils/convertor.js'

export default {
    computed: {
        lastname() {
            return this.$store.getters.getUserData.memberInfo?.lastname
        },
        firstname() {
            return this.$store.getters.getUserData.memberInfo?.firstname
        },
        middlename() {
            return this.$store.getters.getUserData.memberInfo?.middlename
        },
        nameForCard() {
            return this.$store.getters.getUserData.memberInfo?.nameForCard
        },
        addressString() {
            return this.$store.getters.getUserAddressInfoString
        },
        birthdate() {
            return this.$store.getters.getUserData.memberInfo?.birthdate ? convertYMDtoDMY(this.$store.getters.getUserData.memberInfo?.birthdate) : ""
        },
        emailsString() {
            return (this.$store.getters.getUserData.memberInfo?.emails || []).map(email => email.value).join(", ");
        },
        phonesString() {
            return (this.$store.getters.getUserData.memberInfo?.phones || []).map(phone => phone.value).join(", ");
        },
        photo() {
            return this.$store.getters.getUserData.memberInfo?.photo;
        },
    }
};
</script>
